import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import {useContext} from 'react'
import {CustomerReportContext} from '../../context'
import { MIN_DATE_RANGE } from '../../utils'

const CustomerReportsHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')

  const {
    handleCustomerGroupReportDateChange,
    handleCustomerTypeReportDateChange,
  } = useContext(CustomerReportContext)

  const handleDateChange = (startDate: any, endDate: any) => {
    handleCustomerGroupReportDateChange(startDate, endDate)
    handleCustomerTypeReportDateChange(startDate, endDate)
  }

  return (
    <div className='d-flex flex-wrap justify-content-end mb-10'>
      <div className='w-250px'>
        <PredefinedDateRange
          cb={handleDateChange}
          defaultValue={dateRangeLabel || 'Last 90 Days'}
          includeCurrantDay={true}
          startDate={MIN_DATE_RANGE}
        />
      </div>
    </div>
  )
}

export default CustomerReportsHeader
